/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBookingGroupOutput } from "../../entities/models/BookingGroupOutput";
import { modelsPaymentStatusOutputSchema } from "./paymentStatusOutputSchema";
import { modelsTabletBookingOutputSchema } from "./tabletBookingOutputSchema";
import { z } from "zod/v4";

export const modelsBookingGroupOutputSchema = z.object({
    "amount": z.optional(z.number()),
get "booking"(){
                return modelsTabletBookingOutputSchema.optional()
              },
"expires_at": z.optional(z.string()),
get "payment"(){
                return modelsPaymentStatusOutputSchema.optional()
              },
"status": z.optional(z.enum(["awaiting_payment", "paid", "expired"])),
"visit_group_id": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBookingGroupOutput>